import { createActions, createReducer } from 'reduxsauce'

import ConsultaVerbasIndenizatoriasService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaVerbasIndenizatoriasInicio: [],
    buscaConsultaVerbasIndenizatoriasErro: ['erro'],
    buscaConsultaVerbasIndenizatoriasSucesso: ['consultaVerbasIndenizatorias'],
    limpar: [],
    setConsultaVerbasIndenizatoriasEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaVerbasIndenizatorias = (filtro, tipoServidor) => {
    return dispatch => {
        dispatch(Creators.buscaConsultaVerbasIndenizatoriasInicio())
        let serv = new ConsultaVerbasIndenizatoriasService()
        return serv
            .consultaVerbasIndenizatorias(filtro, tipoServidor)
            .then(response => dispatch(Creators.buscaConsultaVerbasIndenizatoriasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaVerbasIndenizatoriasErro(error)))
    }
}

const buscaConsultaVerbasIndenizatoriasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaVerbasIndenizatoriasErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaVerbasIndenizatoriasSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaVerbasIndenizatorias.resultado,
        dataSincronizacaoDados: action.consultaVerbasIndenizatorias.dataSincronizacaoDados,
        carregando: false,
        fonte: action.consultaVerbasIndenizatorias.fonte,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaVerbasIndenizatoriasEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_VERBAS_INDENIZATORIAS_INICIO]: buscaConsultaVerbasIndenizatoriasInicio,
    [Types.BUSCA_CONSULTA_VERBAS_INDENIZATORIAS_ERRO]: buscaConsultaVerbasIndenizatoriasErro,
    [Types.BUSCA_CONSULTA_VERBAS_INDENIZATORIAS_SUCESSO]: buscaConsultaVerbasIndenizatoriasSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_VERBAS_INDENIZATORIAS_ESTADO_DT]: setConsultaVerbasIndenizatoriasEstadoDT,
})
